import { FC } from 'react';

import { Box, BoxProps, Stack, Typography } from '@mui/material';

export enum RiskLevel {
    NONE = 'NONE',
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    RESTRICTED = 'RESTRICTED',
    PROHIBITED = 'PROHIBITED',
}

export const RiskLevelColors = {
    [RiskLevel.NONE]: '#F5F5F5',
    [RiskLevel.LOW]: '#32D583',
    [RiskLevel.MEDIUM]: '#FDCC67',
    [RiskLevel.HIGH]: '#F06C62',
    [RiskLevel.RESTRICTED]: '#F04438',
    [RiskLevel.PROHIBITED]: '#B42318',
};

interface RiskLevelsProps {
    level: string;
    containerStyles?: BoxProps;
}

const RiskLevels: FC<RiskLevelsProps> = ({ level, containerStyles }) => {
    const levels = Object.values(RiskLevel)
        .slice(1)
        .map((mappedLevel) => ({
            mappedLevel,
            active: mappedLevel === level,
        }));

    const getActiveLevelIndex = () => {
        const activeLevel = levels.find((level) => level.active);
        return activeLevel ? levels.indexOf(activeLevel) : -1;
    };

    const getActiveLevelColor = () => {
        const activeLevel = levels.find((level) => level.active);
        return activeLevel ? RiskLevelColors[activeLevel.mappedLevel] : '#F5F5F5';
    };

    return (
        <Box {...containerStyles}>
            <Stack direction="row" spacing={1} py={2}>
                {levels.map((_, index) => (
                    <Box
                        key={index}
                        sx={{
                            backgroundColor:
                                getActiveLevelIndex() >= index ? getActiveLevelColor() : '#F5F5F5',
                            width: '100%',
                            height: '8px',
                            borderRadius: '8px',
                            padding: '0 4px',
                        }}
                    />
                ))}
            </Stack>
            <Typography
                fontSize="12px"
                color={level === RiskLevel.NONE ? '#DADADA' : RiskLevelColors[level]}
                textTransform="capitalize"
            >
                {level === RiskLevel.NONE ? 'Risk Level' : level.toLowerCase()}
            </Typography>
        </Box>
    );
};

export default RiskLevels;
